/* tslint:disable */
/* eslint-disable */
/**
 * GLC.ClientPortal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GHUBCOUNTRY } from './GHUBCOUNTRY';
import {
    GHUBCOUNTRYFromJSON,
    GHUBCOUNTRYFromJSONTyped,
    GHUBCOUNTRYToJSON,
} from './GHUBCOUNTRY';
import type { GHUBETHNICITY } from './GHUBETHNICITY';
import {
    GHUBETHNICITYFromJSON,
    GHUBETHNICITYFromJSONTyped,
    GHUBETHNICITYToJSON,
} from './GHUBETHNICITY';
import type { GHUBGENDER } from './GHUBGENDER';
import {
    GHUBGENDERFromJSON,
    GHUBGENDERFromJSONTyped,
    GHUBGENDERToJSON,
} from './GHUBGENDER';
import type { GHUBLANGUAGE } from './GHUBLANGUAGE';
import {
    GHUBLANGUAGEFromJSON,
    GHUBLANGUAGEFromJSONTyped,
    GHUBLANGUAGEToJSON,
} from './GHUBLANGUAGE';
import type { GHUBMARITALSTATUS } from './GHUBMARITALSTATUS';
import {
    GHUBMARITALSTATUSFromJSON,
    GHUBMARITALSTATUSFromJSONTyped,
    GHUBMARITALSTATUSToJSON,
} from './GHUBMARITALSTATUS';
import type { GHUBNATUREOFPERSON } from './GHUBNATUREOFPERSON';
import {
    GHUBNATUREOFPERSONFromJSON,
    GHUBNATUREOFPERSONFromJSONTyped,
    GHUBNATUREOFPERSONToJSON,
} from './GHUBNATUREOFPERSON';
import type { GHUBORGANISATIONCLASSIFICATION } from './GHUBORGANISATIONCLASSIFICATION';
import {
    GHUBORGANISATIONCLASSIFICATIONFromJSON,
    GHUBORGANISATIONCLASSIFICATIONFromJSONTyped,
    GHUBORGANISATIONCLASSIFICATIONToJSON,
} from './GHUBORGANISATIONCLASSIFICATION';
import type { GHUBORGANISATIONSUBCLASSIFICATION } from './GHUBORGANISATIONSUBCLASSIFICATION';
import {
    GHUBORGANISATIONSUBCLASSIFICATIONFromJSON,
    GHUBORGANISATIONSUBCLASSIFICATIONFromJSONTyped,
    GHUBORGANISATIONSUBCLASSIFICATIONToJSON,
} from './GHUBORGANISATIONSUBCLASSIFICATION';
import type { GHUBPARTYTYPE } from './GHUBPARTYTYPE';
import {
    GHUBPARTYTYPEFromJSON,
    GHUBPARTYTYPEFromJSONTyped,
    GHUBPARTYTYPEToJSON,
} from './GHUBPARTYTYPE';
import type { GHUBTITLE } from './GHUBTITLE';
import {
    GHUBTITLEFromJSON,
    GHUBTITLEFromJSONTyped,
    GHUBTITLEToJSON,
} from './GHUBTITLE';
import type { ProposalViewModel } from './ProposalViewModel';
import {
    ProposalViewModelFromJSON,
    ProposalViewModelFromJSONTyped,
    ProposalViewModelToJSON,
} from './ProposalViewModel';

/**
 * 
 * @export
 * @interface PartyViewModel
 */
export interface PartyViewModel {
    /**
     * 
     * @type {number}
     * @memberof PartyViewModel
     */
    id: number;
    /**
     * 
     * @type {GHUBPARTYTYPE}
     * @memberof PartyViewModel
     */
    partyTypeId: GHUBPARTYTYPE;
    /**
     * 
     * @type {GHUBTITLE}
     * @memberof PartyViewModel
     */
    titleId?: GHUBTITLE;
    /**
     * 
     * @type {GHUBNATUREOFPERSON}
     * @memberof PartyViewModel
     */
    personTypeId?: GHUBNATUREOFPERSON;
    /**
     * 
     * @type {string}
     * @memberof PartyViewModel
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof PartyViewModel
     */
    initials?: string;
    /**
     * 
     * @type {string}
     * @memberof PartyViewModel
     */
    middleName?: string;
    /**
     * 
     * @type {string}
     * @memberof PartyViewModel
     */
    surname?: string;
    /**
     * 
     * @type {string}
     * @memberof PartyViewModel
     */
    previousSurname?: string;
    /**
     * 
     * @type {string}
     * @memberof PartyViewModel
     */
    preferredName?: string;
    /**
     * 
     * @type {GHUBGENDER}
     * @memberof PartyViewModel
     */
    genderId?: GHUBGENDER;
    /**
     * 
     * @type {GHUBMARITALSTATUS}
     * @memberof PartyViewModel
     */
    martialStatusId?: GHUBMARITALSTATUS;
    /**
     * 
     * @type {boolean}
     * @memberof PartyViewModel
     */
    hasFounders?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PartyViewModel
     */
    hasTrustees?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PartyViewModel
     */
    hasTrustBeneficiaries?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PartyViewModel
     */
    hasPersonsAuthorised?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PartyViewModel
     */
    hasSouthAfricanIDNumber?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof PartyViewModel
     */
    dateOfBirth?: Date;
    /**
     * 
     * @type {GHUBCOUNTRY}
     * @memberof PartyViewModel
     */
    nationalityCountryId?: GHUBCOUNTRY;
    /**
     * 
     * @type {string}
     * @memberof PartyViewModel
     */
    identityNumber?: string;
    /**
     * 
     * @type {GHUBCOUNTRY}
     * @memberof PartyViewModel
     */
    countryOfBirthId?: GHUBCOUNTRY;
    /**
     * 
     * @type {string}
     * @memberof PartyViewModel
     */
    passportNumber?: string;
    /**
     * 
     * @type {GHUBCOUNTRY}
     * @memberof PartyViewModel
     */
    passportCountryOfIssue?: GHUBCOUNTRY;
    /**
     * 
     * @type {Date}
     * @memberof PartyViewModel
     */
    passportExpiryDate?: Date;
    /**
     * 
     * @type {GHUBETHNICITY}
     * @memberof PartyViewModel
     */
    ethnicity?: GHUBETHNICITY;
    /**
     * 
     * @type {boolean}
     * @memberof PartyViewModel
     */
    allTrustBeneficiariesAreIndividuals?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PartyViewModel
     */
    organisationName?: string;
    /**
     * 
     * @type {string}
     * @memberof PartyViewModel
     */
    registrationNumber?: string;
    /**
     * 
     * @type {GHUBCOUNTRY}
     * @memberof PartyViewModel
     */
    countryOfResidenceId?: GHUBCOUNTRY;
    /**
     * 
     * @type {Date}
     * @memberof PartyViewModel
     */
    dateOfIncorporation?: Date;
    /**
     * 
     * @type {string}
     * @memberof PartyViewModel
     */
    tradingName?: string;
    /**
     * 
     * @type {GHUBNATUREOFPERSON}
     * @memberof PartyViewModel
     */
    organisationTypeId?: GHUBNATUREOFPERSON;
    /**
     * 
     * @type {GHUBCOUNTRY}
     * @memberof PartyViewModel
     */
    registrationNumberCountryId?: GHUBCOUNTRY;
    /**
     * 
     * @type {GHUBCOUNTRY}
     * @memberof PartyViewModel
     */
    incorporationCountryId?: GHUBCOUNTRY;
    /**
     * 
     * @type {string}
     * @memberof PartyViewModel
     */
    businessActivity?: string;
    /**
     * 
     * @type {GHUBLANGUAGE}
     * @memberof PartyViewModel
     */
    contactCommunicationLanguageId?: GHUBLANGUAGE;
    /**
     * 
     * @type {string}
     * @memberof PartyViewModel
     */
    contactPersonName?: string;
    /**
     * 
     * @type {string}
     * @memberof PartyViewModel
     */
    contactPersonSurname?: string;
    /**
     * 
     * @type {string}
     * @memberof PartyViewModel
     */
    contactPersonInitials?: string;
    /**
     * 
     * @type {GHUBTITLE}
     * @memberof PartyViewModel
     */
    contactPersonTitleId?: GHUBTITLE;
    /**
     * 
     * @type {string}
     * @memberof PartyViewModel
     */
    contactPersonDesignation?: string;
    /**
     * 
     * @type {GHUBORGANISATIONCLASSIFICATION}
     * @memberof PartyViewModel
     */
    organisationClassificationId?: GHUBORGANISATIONCLASSIFICATION;
    /**
     * 
     * @type {GHUBORGANISATIONSUBCLASSIFICATION}
     * @memberof PartyViewModel
     */
    organisationSubClassificationId?: GHUBORGANISATIONSUBCLASSIFICATION;
    /**
     * 
     * @type {GHUBORGANISATIONSUBCLASSIFICATION}
     * @memberof PartyViewModel
     */
    noGIINumberReason?: GHUBORGANISATIONSUBCLASSIFICATION;
    /**
     * 
     * @type {string}
     * @memberof PartyViewModel
     */
    giiNumber?: string;
    /**
     * 
     * @type {GHUBLANGUAGE}
     * @memberof PartyViewModel
     */
    languageId?: GHUBLANGUAGE;
    /**
     * 
     * @type {boolean}
     * @memberof PartyViewModel
     */
    isUsCitizen?: boolean;
    /**
     * 
     * @type {GHUBCOUNTRY}
     * @memberof PartyViewModel
     */
    countryOfOperationId?: GHUBCOUNTRY;
    /**
     * 
     * @type {ProposalViewModel}
     * @memberof PartyViewModel
     */
    proposal?: ProposalViewModel;
}

/**
 * Check if a given object implements the PartyViewModel interface.
 */
export function instanceOfPartyViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "partyTypeId" in value;

    return isInstance;
}

export function PartyViewModelFromJSON(json: any): PartyViewModel {
    return PartyViewModelFromJSONTyped(json, false);
}

export function PartyViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): PartyViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['Id'],
        'partyTypeId': GHUBPARTYTYPEFromJSON(json['PartyTypeId']),
        'titleId': !exists(json, 'TitleId') ? undefined : GHUBTITLEFromJSON(json['TitleId']),
        'personTypeId': !exists(json, 'PersonTypeId') ? undefined : GHUBNATUREOFPERSONFromJSON(json['PersonTypeId']),
        'firstName': !exists(json, 'FirstName') ? undefined : json['FirstName'],
        'initials': !exists(json, 'Initials') ? undefined : json['Initials'],
        'middleName': !exists(json, 'MiddleName') ? undefined : json['MiddleName'],
        'surname': !exists(json, 'Surname') ? undefined : json['Surname'],
        'previousSurname': !exists(json, 'PreviousSurname') ? undefined : json['PreviousSurname'],
        'preferredName': !exists(json, 'PreferredName') ? undefined : json['PreferredName'],
        'genderId': !exists(json, 'GenderId') ? undefined : GHUBGENDERFromJSON(json['GenderId']),
        'martialStatusId': !exists(json, 'MartialStatusId') ? undefined : GHUBMARITALSTATUSFromJSON(json['MartialStatusId']),
        'hasFounders': !exists(json, 'HasFounders') ? undefined : json['HasFounders'],
        'hasTrustees': !exists(json, 'HasTrustees') ? undefined : json['HasTrustees'],
        'hasTrustBeneficiaries': !exists(json, 'HasTrustBeneficiaries') ? undefined : json['HasTrustBeneficiaries'],
        'hasPersonsAuthorised': !exists(json, 'HasPersonsAuthorised') ? undefined : json['HasPersonsAuthorised'],
        'hasSouthAfricanIDNumber': !exists(json, 'HasSouthAfricanIDNumber') ? undefined : json['HasSouthAfricanIDNumber'],
        'dateOfBirth': !exists(json, 'DateOfBirth') ? undefined : (new Date(json['DateOfBirth'])),
        'nationalityCountryId': !exists(json, 'NationalityCountryId') ? undefined : GHUBCOUNTRYFromJSON(json['NationalityCountryId']),
        'identityNumber': !exists(json, 'IdentityNumber') ? undefined : json['IdentityNumber'],
        'countryOfBirthId': !exists(json, 'CountryOfBirthId') ? undefined : GHUBCOUNTRYFromJSON(json['CountryOfBirthId']),
        'passportNumber': !exists(json, 'PassportNumber') ? undefined : json['PassportNumber'],
        'passportCountryOfIssue': !exists(json, 'PassportCountryOfIssue') ? undefined : GHUBCOUNTRYFromJSON(json['PassportCountryOfIssue']),
        'passportExpiryDate': !exists(json, 'PassportExpiryDate') ? undefined : (new Date(json['PassportExpiryDate'])),
        'ethnicity': !exists(json, 'Ethnicity') ? undefined : GHUBETHNICITYFromJSON(json['Ethnicity']),
        'allTrustBeneficiariesAreIndividuals': !exists(json, 'AllTrustBeneficiariesAreIndividuals') ? undefined : json['AllTrustBeneficiariesAreIndividuals'],
        'organisationName': !exists(json, 'OrganisationName') ? undefined : json['OrganisationName'],
        'registrationNumber': !exists(json, 'RegistrationNumber') ? undefined : json['RegistrationNumber'],
        'countryOfResidenceId': !exists(json, 'CountryOfResidenceId') ? undefined : GHUBCOUNTRYFromJSON(json['CountryOfResidenceId']),
        'dateOfIncorporation': !exists(json, 'DateOfIncorporation') ? undefined : (new Date(json['DateOfIncorporation'])),
        'tradingName': !exists(json, 'TradingName') ? undefined : json['TradingName'],
        'organisationTypeId': !exists(json, 'OrganisationTypeId') ? undefined : GHUBNATUREOFPERSONFromJSON(json['OrganisationTypeId']),
        'registrationNumberCountryId': !exists(json, 'RegistrationNumberCountryId') ? undefined : GHUBCOUNTRYFromJSON(json['RegistrationNumberCountryId']),
        'incorporationCountryId': !exists(json, 'IncorporationCountryId') ? undefined : GHUBCOUNTRYFromJSON(json['IncorporationCountryId']),
        'businessActivity': !exists(json, 'BusinessActivity') ? undefined : json['BusinessActivity'],
        'contactCommunicationLanguageId': !exists(json, 'ContactCommunicationLanguageId') ? undefined : GHUBLANGUAGEFromJSON(json['ContactCommunicationLanguageId']),
        'contactPersonName': !exists(json, 'ContactPersonName') ? undefined : json['ContactPersonName'],
        'contactPersonSurname': !exists(json, 'ContactPersonSurname') ? undefined : json['ContactPersonSurname'],
        'contactPersonInitials': !exists(json, 'ContactPersonInitials') ? undefined : json['ContactPersonInitials'],
        'contactPersonTitleId': !exists(json, 'ContactPersonTitleId') ? undefined : GHUBTITLEFromJSON(json['ContactPersonTitleId']),
        'contactPersonDesignation': !exists(json, 'ContactPersonDesignation') ? undefined : json['ContactPersonDesignation'],
        'organisationClassificationId': !exists(json, 'OrganisationClassificationId') ? undefined : GHUBORGANISATIONCLASSIFICATIONFromJSON(json['OrganisationClassificationId']),
        'organisationSubClassificationId': !exists(json, 'OrganisationSubClassificationId') ? undefined : GHUBORGANISATIONSUBCLASSIFICATIONFromJSON(json['OrganisationSubClassificationId']),
        'noGIINumberReason': !exists(json, 'NoGIINumberReason') ? undefined : GHUBORGANISATIONSUBCLASSIFICATIONFromJSON(json['NoGIINumberReason']),
        'giiNumber': !exists(json, 'GiiNumber') ? undefined : json['GiiNumber'],
        'languageId': !exists(json, 'LanguageId') ? undefined : GHUBLANGUAGEFromJSON(json['LanguageId']),
        'isUsCitizen': !exists(json, 'IsUsCitizen') ? undefined : json['IsUsCitizen'],
        'countryOfOperationId': !exists(json, 'CountryOfOperationId') ? undefined : GHUBCOUNTRYFromJSON(json['CountryOfOperationId']),
        'proposal': !exists(json, 'Proposal') ? undefined : ProposalViewModelFromJSON(json['Proposal']),
    };
}

export function PartyViewModelToJSON(value?: PartyViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'Id': value.id,
        'PartyTypeId': GHUBPARTYTYPEToJSON(value.partyTypeId),
        'TitleId': GHUBTITLEToJSON(value.titleId),
        'PersonTypeId': GHUBNATUREOFPERSONToJSON(value.personTypeId),
        'FirstName': value.firstName,
        'Initials': value.initials,
        'MiddleName': value.middleName,
        'Surname': value.surname,
        'PreviousSurname': value.previousSurname,
        'PreferredName': value.preferredName,
        'GenderId': GHUBGENDERToJSON(value.genderId),
        'MartialStatusId': GHUBMARITALSTATUSToJSON(value.martialStatusId),
        'HasFounders': value.hasFounders,
        'HasTrustees': value.hasTrustees,
        'HasTrustBeneficiaries': value.hasTrustBeneficiaries,
        'HasPersonsAuthorised': value.hasPersonsAuthorised,
        'HasSouthAfricanIDNumber': value.hasSouthAfricanIDNumber,
        'DateOfBirth': value.dateOfBirth === undefined ? undefined : (value.dateOfBirth.toISOString()),
        'NationalityCountryId': GHUBCOUNTRYToJSON(value.nationalityCountryId),
        'IdentityNumber': value.identityNumber,
        'CountryOfBirthId': GHUBCOUNTRYToJSON(value.countryOfBirthId),
        'PassportNumber': value.passportNumber,
        'PassportCountryOfIssue': GHUBCOUNTRYToJSON(value.passportCountryOfIssue),
        'PassportExpiryDate': value.passportExpiryDate === undefined ? undefined : (value.passportExpiryDate.toISOString()),
        'Ethnicity': GHUBETHNICITYToJSON(value.ethnicity),
        'AllTrustBeneficiariesAreIndividuals': value.allTrustBeneficiariesAreIndividuals,
        'OrganisationName': value.organisationName,
        'RegistrationNumber': value.registrationNumber,
        'CountryOfResidenceId': GHUBCOUNTRYToJSON(value.countryOfResidenceId),
        'DateOfIncorporation': value.dateOfIncorporation === undefined ? undefined : (value.dateOfIncorporation.toISOString()),
        'TradingName': value.tradingName,
        'OrganisationTypeId': GHUBNATUREOFPERSONToJSON(value.organisationTypeId),
        'RegistrationNumberCountryId': GHUBCOUNTRYToJSON(value.registrationNumberCountryId),
        'IncorporationCountryId': GHUBCOUNTRYToJSON(value.incorporationCountryId),
        'BusinessActivity': value.businessActivity,
        'ContactCommunicationLanguageId': GHUBLANGUAGEToJSON(value.contactCommunicationLanguageId),
        'ContactPersonName': value.contactPersonName,
        'ContactPersonSurname': value.contactPersonSurname,
        'ContactPersonInitials': value.contactPersonInitials,
        'ContactPersonTitleId': GHUBTITLEToJSON(value.contactPersonTitleId),
        'ContactPersonDesignation': value.contactPersonDesignation,
        'OrganisationClassificationId': GHUBORGANISATIONCLASSIFICATIONToJSON(value.organisationClassificationId),
        'OrganisationSubClassificationId': GHUBORGANISATIONSUBCLASSIFICATIONToJSON(value.organisationSubClassificationId),
        'NoGIINumberReason': GHUBORGANISATIONSUBCLASSIFICATIONToJSON(value.noGIINumberReason),
        'GiiNumber': value.giiNumber,
        'LanguageId': GHUBLANGUAGEToJSON(value.languageId),
        'IsUsCitizen': value.isUsCitizen,
        'CountryOfOperationId': GHUBCOUNTRYToJSON(value.countryOfOperationId),
        'Proposal': ProposalViewModelToJSON(value.proposal),
    };
}

